import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export default function SectionEyebrow({ children }) {
  return <div className="eyebrow font-sans-body">{children}</div>;
}

export function SectionHeading({ eyebrow, title, subtitle, center = true, invert = false }) {
  const alignCls = center ? 'text-center mx-auto' : '';
  return (
    <div className={`${alignCls} max-w-3xl`}>
      {eyebrow && (
        <div className={`${center ? 'justify-center' : ''} flex`}>
          <span className="eyebrow">{eyebrow}</span>
        </div>
      )}
      <h2
        className={`mt-4 text-[2.1rem] sm:text-[2.6rem] leading-[1.1] font-semibold ${
          invert ? 'text-white' : 'text-aqc-navy'
        }`}
      >
        {title}
      </h2>
      {center && <div className="section-title-divider" />}
      {subtitle && (
        <p
          className={`text-[1.02rem] leading-relaxed ${invert ? 'text-white/80' : 'text-aqc-muted'} ${
            center ? 'mt-2' : 'mt-4'
          }`}
        >
          {subtitle}
        </p>
      )}
    </div>
  );
}

export function LearnMore({ to, children = 'Learn more' }) {
  return (
    <Link to={to} className="link-underline text-[0.78rem] uppercase tracking-[0.14em]">
      {children} <ArrowRight size={14} />
    </Link>
  );
}

// Watermark component intentionally removed per exact-replica requirements.
export function Watermark() {
  return null;
}
